import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "button", "dropdown" ]
  static values = { dropdownShow: Boolean }

  connect() {
    this.createClickOutsideCallback()
    // Initialize the dropdown state
    this.dropdownShowValueChanged()
  }

  disconnect() {
    if (this.dropdownShowValue = true) {
      this.dropdownShowValue = false
    }
  }

  createClickOutsideCallback() {
    this.clickOutsideCallback = (event) => {
      if (!this.buttonTarget.contains(event.target) && !this.dropdownTarget.contains(event.target)) {
        this.dropdownShowValue = false
        window.removeEventListener('click', this.clickOutsideCallback)
      }
    }
  }

  showDropdown(event) {
    event.preventDefault()
    this.dropdownShowValue = true
    window.addEventListener('click', this.clickOutsideCallback)
  }

  hideDropdown(event) {
    event.preventDefault()
    this.dropdownShowValue = false
    window.removeEventListener('click', this.clickOutsideCallback)
  }

  toggle(event) {
    event.preventDefault()

    if (this.dropdownShowValue) {
      this.dropdownShowValue = false
      window.removeEventListener('click', this.clickOutsideCallback)
    } else {
      this.dropdownShowValue = true
      window.addEventListener('click', this.clickOutsideCallback)
    }
  }

  dropdownShowValueChanged() {
    if (this.dropdownShowValue) {
      this.dropdownTarget.classList.remove('invisible')
    } else {
      this.dropdownTarget.classList.add('invisible')
    }
  }
}
